import { render, staticRenderFns } from "./ArrowSettings.vue?vue&type=template&id=531abaae&scoped=true&"
import script from "./ArrowSettings.vue?vue&type=script&lang=js&"
export * from "./ArrowSettings.vue?vue&type=script&lang=js&"
import style0 from "./ArrowSettings.vue?vue&type=style&index=0&id=531abaae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531abaae",
  null
  
)

export default component.exports